import Vue from 'vue';
import VueRouter from 'vue-router';
import { prodKey } from '../../config'

Vue.use(VueRouter);

export const createRouter = () => {
  let host
  const routes = [
    {
      path: '/',
      name: 'index',
      alias: ['/index', '/index.html', '/ut-launch-slp/index.html', '/ut-webx/ut-launch-slp/index.html'],
      component: () => import(/* webpackChunkName: "index" */ '@/views/Index/index.vue'),
      fetch: () => import(/* webpackChunkName: "index-id-fetch" */ '@/views/Index/fetch.js')
    }
  ];
  if (!__isServerRender__) {
    host = window.location.host
  }
  const csrHost = ['page-test.intra.xiaojukeji.com', 'pre-page.udache.com', 'page.udache.com', 'localhost:3003', 'localhost:9000']
  const base = !__isServerRender__ && csrHost.includes(host)
  const router = new VueRouter({
    mode: 'history',
    base: base ? '/' : `/${prodKey}/`,
    routes,
  });

  return router;
};


/*
/ csr /ut-webx/ut-launch-slp/index.html fasle client url
prodKey ssg /ut-xlp true server
prodKey ssg降级 /ut-xlp fasle client url

!__isServerRender__ && client && page.udache.com ? '/' :  `/${prodKey}/`

http://page-test.intra.xiaojukeji.com/
https://pre-page.udache.com/
https://page.udache.com/


*/
